import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-stethoscope",
  templateUrl: "./med-icon-stethoscope.component.html",
})
export class MedIconStethoscopeComponent extends SvgMixinComponent {}
